"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgZoomAreaOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M28.69 27.29L25 23.61a5.44 5.44 0 001-3.11 5.5 5.5 0 10-2.4 4.5l3.68 3.68zM20.48 24A3.5 3.5 0 1124 20.5a3.5 3.5 0 01-3.52 3.5zM3.98 8h2v2h-2zM3.98 12h2v2h-2zM3.98 16h2v2h-2zM3.98 20h2v2h-2zM7.98 24h2v2h-2zM11.98 24h2v2h-2zM7.98 4h2v2h-2zM11.98 4h2v2h-2zM15.98 4h2v2h-2zM19.98 4h2v2h-2zM23.98 8h2v2h-2zM23.98 12h2v2h-2zM3.98 4h2v2h-2zM23.98 4h2v2h-2zM3.98 24h2v2h-2z" })));
}
exports.default = SvgZoomAreaOutline;
//# sourceMappingURL=ZoomAreaOutline.js.map